<template>
  <div class="cam--items">
    <div class="cam--item" v-for="item in frameStreams" :key="item.id">
      <b-form-radio size="sm" v-model="selectedCamId" :value="item.id">{{$t('printers.camera.cameraName', {num: item.id})}}</b-form-radio>
      <b-img v-bind="imgProps" :src="item.src" @click="selectedCamId = item.id"></b-img>
    </div>
    <div class="cam--item">
      <b-form-radio size="sm" v-model="selectedCamId" value="0" :disabled="!enabled">{{$t('printers.camera.noCamera')}}</b-form-radio>
      <b-img v-bind="imgProps" blank @click="selectedCamId = 0"></b-img>
    </div>
  </div>
</template>

<script>
  import Camera from "@/mixins/camera";
  import {mapActions} from "vuex";
  import Vue from "vue";

  export default {
    name: 'printer-camera-picker',
    props: ['printerId', 'webcamId', 'enabled'],
    mixins: [Camera],
    data() {
      return {
        imgProps: {blankColor: '#777', width: 161, height: 123, rounded: 'top', thumbnail: true},
        listStream: null,
        frameStreams: {},
        selectedCamId: 0
      }
    },
    created() {
      if (this.enabled) {
        this.startStreamCameraList();
        this.selectedCamId = this.webcamId;
        console.log(this.selectedCamId);
      }
    },
    beforeDestroy() {
      this._detachStreams();
    },
    watch: {
      enabled: function(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        if (newVal) {
          this.startStreamCameraList();
        } else {
          this._detachStreams();
          this.frameStreams = {};
        }
      }
    },
    methods: {
      ...mapActions(['getCameraListToken']),

      startStreamCameraList() {
        this.getCameraListToken(this.printerId).then(({data}) => {
          if (data.result) {
            this.listStream = this.allocateGrpcService().streamCameraList(data.message.token, this._handleCameraListStreamData, (e) => {
              //TODO: handle camera list stream errors
              console.log(e);
            });
          }
        })
      },

      _handleCameraListStreamData(data, type) {
        if (type === 'data') {
          if (data.getJustHeartbeat()) {
            return;
          }
          const token = data.getFrameStreamToken();
          if (this.frameStreams[token] !== undefined && this.frameStreams[token].stream) {
            //Stop previous frame stream
            this.frameStreams[token].stream.cancel();
          }
          if (data.getActive()) {
            if (this.frameStreams[token] === undefined) {
              Vue.set(this.frameStreams, token, {
                stream: null,
                src: this.getConnectionImage(),
                id: data.getCameraName()
              });
            }
            this.startStreamCameraFrame(token, data.getBase64());
          } else if (this.frameStreams[token] !== undefined) {
            if (this.frameStreams[token].id == this.selectedCamId) {
              this.selectedCamId = 0;
            }
            Vue.delete(this.frameStreams, token);
          }
        }
      },

      startStreamCameraFrame(frameStreamToken, isBase64) {
        this.frameStreams[frameStreamToken].stream = this.allocateGrpcService().streamCameraFrame(frameStreamToken, (frame) => {
          if (frame.getJustHeartbeat() || frame.getFrame().length <= 1) {
            return;
          }
          this.frameStreams[frameStreamToken].src = this.convertFrameToUrlData(frame, isBase64);
        }, (e) => {
          //TODO: handle error
          this.frameStreams[frameStreamToken].src = this.getNoCameraImage();
          console.log(e);
        })
      },

      getSelectedCamera() {
        return this.selectedCamId;
      },

      _detachStreams() {
        for (let token in this.frameStreams) {
          if (this.frameStreams[token].stream) {
            this.frameStreams[token].stream.cancel();
          }
        }
        if (this.listStream) {
          this.listStream.cancel();
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .cam--items {
    display: flex;
    overflow-x: scroll;

    img {
      cursor: pointer;
    }
  }
</style>